<div class="guides">
    <div *ngFor="let guide of guides" appPreventDoubleClick (throttledClick)="openGuideDialog(guide)" class="guide">
        <img [src]="guide.image" alt="guide.image" />
        <div class="title">{{ guide.title }}</div>
    </div>
</div>

<div class="quick-start">
    <div>
        <div class="top">New to goal setting?</div>
        <div class="bottom">Check out our quick start guide to learn how to set and track your goals</div>
    </div>

    <button mat-raised-button setColor="primaryColour" color="primary">View quick start guide</button> 
</div>